import { render } from "./Create.vue?vue&type=template&id=c601be9a&ts=true"
import script from "./Create.vue?vue&type=script&lang=ts"
export * from "./Create.vue?vue&type=script&lang=ts"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__